import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../store';
import { SelectionButton } from 'src/components/shared/selection-button/selection-button';
import { ExportOptions } from '../reports-and-logs/logs/export/export-options';
import usePromiseFeedback from 'src/components/shared/promise-feedback/usePromiseFeedback';
import { EventType } from 'src/dtos/analytics.dto';
import { toast } from '../../shared/toast-notifications';
import { NotificationType } from '../../../utils/enums';

export const ExportActivityLogs: React.FC = observer(() => {
    const { activityStore } = useStores();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();

    const onSelectedExportMethod = (value: any) => {
        activityStore.setExportMethod(value);
        onExport();
    };

    const onExport = () => {
        toast(NotificationType.SUCCESS,
            'Activity results are now being prepared and downloaded to your computer');
        promiseFeedbackFactory({
                promise: activityStore.downloadLogs(),
                successCallback: () => activityStore.sendActivityEvent(EventType.ActivityLogsExport, { exportMethod: activityStore.exportLogMethod.key }),
                notifObj: { show: false }
        });
    };

    return <>
        <SelectionButton options={ExportOptions.slice(0, 2)} onClick={onExport} label={'Export Results'} width={230}
            prefixIconType={activityStore.exportLogMethod.icon} onSelect={onSelectedExportMethod} disable={false} />
        {promiseContextHolder}
    </>;
});
